<template>
  <div class="detalle">

    <!-- <nav>
      <p>Mygirlweb</p>
      <img src="../assets/iconos/menu.png" alt="">

    </nav> -->

    <div class="mainInner"  v-on:scroll="handleScroll" >
    
      <p class="title">Titulo</p>
      <p class="subtitle">Subtitulo</p>

      <div class="row" id="home">
        <div class="articulo">
          
          <img src="../assets/girl.jpg" alt="">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

          <img src="../assets/girl2.jpg" alt="">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

          <img src="../assets/girl3.jpg" alt="">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

          <img src="../assets/girl4.jpg" alt="">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

          <br>
          <p>Autor: Nuria</p>

        </div>

      </div>
            
      
    </div>

    
  </div>
</template>

<script>
  export default {
    created() 
    {
      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() 
    {
      window.removeEventListener("scroll", this.handleScroll);
    },
    data: function () {
      return {
        
      };
    },
    methods: 
    {
      handleScroll: function () {},
      
      scrollHome: function () 
      {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });

      },

      
    },
    computed: {},
    mounted: function () {
      this.scrollHome();     
    }
  }
</script>

<style scoped>
  @font-face 
  {
    font-family: monR;
    src: url('../assets/Montserrat/Montserrat-Regular.ttf');
  }

  @font-face 
  {
    font-family: monB;
    src: url('../assets/Montserrat/Montserrat-SemiBold.ttf');
  }

  a
  {
    text-decoration-color: #707070 !important;
  }
  
  .detalle
  {  
    overflow: auto;
    scroll-snap-type: y mandatory;
    background-image: url("../assets/iconos/textura2.png"), url("../assets/iconos/textura3.png");
    background-repeat: no-repeat, no-repeat;
    background-position: 90% 30%, bottom left;
    background-attachment: fixed;
  }

  
  .mainInner
  {
    width: 100%;
    height: auto;
    margin-top: 115px;

    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }

  .title
  {
    font-size: 30px;
    font-family: monB;
    margin: 0;
    color: #3A3A3A;
  }

  .subtitle
  {
    font-size: 24px;
    font-family: monB;
    color: #3A3A3A;    
  }

  .row 
  {
    width: 100%;
    
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }

  .articulo
  {
    width: 100%;
    margin-bottom: 5px;

    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }

  .articulo img 
  {
    width: 100%;
    height: auto;
    border: 2px dotted #DDAAAA;
    box-sizing: border-box;
  }

  .articulo p 
  {
    color: #3A3A3A;
    font-family: monR;
    font-size: 24px;
    text-align: left;
    letter-spacing: 1px;
    line-height: 1.6;
    
  }

  footer
  {
    width: 100%;
    height: 180px;
    margin-top: 30px;

    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
  }

  .redes
  {
    width: 25%;

    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .redes img 
  {
    width: 25px;
    height: 25px;
  }

  footer p 
  {
    margin: 0;
    color: #707070;
  }

  /*Tablets & larger smartphones*/
  @media (min-width:561px) and (max-width:850px)
  {
    .title
    {
      font-size: 34px;
    }

    .subtitle 
    {
      font-size: 28px;
    }

    .articulo p 
    {
      font-size: 28px;
    }
    
  }

  /*Laptops & largers tables in landscape and small desktop*/
  @media (min-width:851px) and (max-width:1279px)
  {
    .detalle
    {
      background-position: 90% 10%, 10% 80%;
    }

    .title
    {
      font-size: 39px;
    }

    .subtitle 
    {
      font-size: 33px;
    }

    .articulo p 
    {
      font-size: 33px;
    }
    
  }

  /*Larger desktops and monitors*/
  @media (min-width:1280px)
  {
    .detalle
    {
      background-position: 90% 10%, 10% 80%;
    }

    .title
    {
      font-size: 35px;
      
    }

    .subtitle 
    {
      font-size: 28px;
    }

    .articulo p 
    {
      font-size: 28px;
    }

    .mainInner 
    {
      width: 75%;
    }

  }



  
</style>